import { Badge } from '@mantine/core';
export const badgeComponent = Badge.extend({
    styles: {
        label: {
            overflow: 'visible',
        },
    },
});
